<template>
  <div id="lab">
    <div class="container-m-auto">
      <div class="row text-left">
        <div class="col-xs-1 col-sm-2 p-4 bg-info">
          <div class="d-none d-lg-block">
            <p class="font-weight-bold">Experiment Selector:</p>
            <div v-for="experiment in data.experiments" :key="experiment.title">
              <b-form-radio
                v-model="experimentselected"
                name="experimentSelect"
                :id="experiment.name"
                :value="experiment.name"
                v-on:input="onChange()"
                >{{ experiment.title }}</b-form-radio
              >
            </div>
          </div>

          <div class="d-block d-lg-none">
            <p class="font-weight-bold">Experiment Selector:</p>

            <b-form-select v-model="experimentselected" size="sm">
              <option
                v-for="experiment in data.experiments"
                :key="experiment.title"
                v-bind:value="experiment.name"
              >
                {{ experiment.title }}
              </option>
            </b-form-select>
          </div>
        </div>
        <div
          class="bg-light"
          :class="
            displayrightpane ? 'col-xs-8 col-sm-8' : 'col-xs-10 col-sm-10'
          "
        >
          <div class="container">
            <div class="row">
              <div class="col-sm-auto">
                Row:
                <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend">
                    <button
                      class="btn btn-info"
                      type="button"
                      v-on:click="buttonDown()"
                    >
                      <v-icon small dark>keyboard_arrow_down</v-icon>
                    </button>
                  </div>

                  <b-form-input
                    class="border-info"
                    id="row"
                    :value="i"
                    size="sm"
                    v-model="i"
                    readonly
                  ></b-form-input>
                  <div class="input-group-append">
                    <button
                      class="btn btn-info"
                      type="button"
                      v-on:click="buttonUp()"
                    >
                      <v-icon small dark>keyboard_arrow_up</v-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-auto">
                Column:
                <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend">
                    <button
                      class="btn btn-info"
                      type="button"
                      v-on:click="buttonLeft()"
                    >
                      <v-icon small dark>keyboard_arrow_left</v-icon>
                    </button>
                  </div>

                  <b-form-input
                    class="border-info"
                    id="column"
                    :value="j"
                    size="sm"
                    v-model="j"
                    readonly
                  ></b-form-input>
                  <div class="input-group-append">
                    <button
                      class="btn btn-info"
                      type="button"
                      v-on:click="buttonRight()"
                    >
                      <v-icon small dark>keyboard_arrow_right</v-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="container" v-if="getFormat() == 1">
                <div class="row">
                  <div class="col-sm-6">
                    <b-img :src="images[0].image" fluid />
                  </div>

                  <div class="col-sm-6">
                    <b-img :src="images[1].image" fluid />
                    <figcaption class="figure-caption">
                      Image: {{ indexes[1].index }}
                    </figcaption>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6"></div>
                  <div class="col-sm-6">
                    <b-img :src="images[2].image" fluid />
                    <figcaption class="figure-caption">
                      Image: {{ indexes[2].index }}
                    </figcaption>
                  </div>
                </div>
              </div>
              <div class="container" v-if="getFormat() == 2">
                <div class="row">
                  <div class="col-sm-6">
                    <b-img :src="images[0].image" fluid />
                  </div>

                  <div class="col-sm-6">
                    <b-img :src="images[1].image" fluid />
                    <figcaption class="figure-caption">
                      Image: {{ indexes[1].index }}
                    </figcaption>
                  </div>
                </div>
              </div>
              <div class="container" v-if="getFormat() == 3">
                <div class="row">
                  <div class="col-sm-6">
                    <b-img :src="images[1].image" fluid />
                    <figcaption class="figure-caption">
                      Image: {{ indexes[1].index }}
                    </figcaption>
                  </div>
                  <div class="col-sm-6">
                    <b-img :src="images[2].image" fluid />
                    <figcaption class="figure-caption">
                      Image: {{ indexes[2].index }}
                    </figcaption>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="displayrightpane" class="col-xs-1 col-sm-2 p-4 bg-info">
          <div class="d-none d-lg-block">
            <p class="font-weight-bold">Experiment Attributes:</p>
            <div
              class="input-group input-group-sm mb-3"
              v-for="attribute in data.attributes"
              :key="attribute.name"
            >
              <div class="input-group-prepend input-group-prepend-1">
                <span class="input-group-text">{{ attribute.title }}</span>
              </div>

              <b-form-input
                :id="attribute.name"
                :value="data.experiments[experimentselected][attribute.name]"
              ></b-form-input>
            </div>
          </div>
          <div class="d-block d-lg-none">
            <p class="font-weight-bold">Experiment Attributes:</p>
            <div class="input-group input-group-sm mb-3">
              <div class="input-group-prepend">
                <b-form-select v-model="attributeselected" size="sm">
                  <option
                    v-for="attribute in data.attributes"
                    :key="attribute.name"
                    v-bind:value="attribute.name"
                  >
                    {{ attribute.title }}
                  </option>
                </b-form-select>
              </div>
              <b-form-input
                :id="attributeselected"
                :value="data.experiments[experimentselected][attributeselected]"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-1 p-4">
      <div class="d-block d-sm-none">
        <div class="fixed-bottom text-center bg-dark">
          <v-btn fab dark small color="normal" v-on:click="buttonLeft()">
            <v-icon dark large>arrow_left</v-icon>
          </v-btn>
          <v-btn fab dark small color="normal" v-on:click="buttonUp()">
            <v-icon dark large>arrow_drop_up</v-icon>
          </v-btn>
          <v-btn fab dark small color="normal" v-on:click="buttonDown()">
            <v-icon dark large>arrow_drop_down</v-icon>
          </v-btn>
          <v-btn fab dark small color="normal" v-on:click="buttonRight()">
            <v-icon dark large>arrow_right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import json from ".././assets/data.json";

export default {
  name: "HomeView",
  data() {
    return {
      displayrightpane: false,
      data: json,
      experimentselected: "",
      attributeselected: "startrow",
      images: [{ image: "" }, { image: "" }, { image: "" }],
      indexes: [{ index: "0000" }, { index: "" }, { index: "" }],
      i: 0,
      j: 0,
      nu: 0,
      nd: 0,
      imageindex: "",
      tempimage: require("./../assets/images/images-alignccd/Cam_0000.jpg"),
    };
  },
  methods: {
    buttonUp() {
      console.log("[log]" + "Up");

      var startrow = parseInt(
        this.data.experiments[this.experimentselected].startrow
      );
      var endrow = parseInt(
        this.data.experiments[this.experimentselected].endrow
      );
      var hysteresis = parseInt(
        this.data.experiments[this.experimentselected].hysteresis
      );

      if (hysteresis == 0) {
        if (this.i == endrow - 1) return;
        else this.i += 1;
      } else if (hysteresis != 0 && this.experimentselected == "focusdemo") {
        // if (this.i == startrow) return;
        // else {
        //   if (this.nd == hysteresis) this.i -= 1;
        //   else {
        //     this.nu = 0;
        //     this.nd++;
        //   }
        // }
        if (this.i == startrow) return;
        else {
          this.i -= 1;
          if (this.nd != hysteresis) {
            this.nu = 0;
            this.nd++;
          }
        }
      } else if (hysteresis != 0 && this.experimentselected == "calibratemic") {
        if (this.i == endrow - 1) return;
        else {
          this.i += 1;
          if (this.nu != hysteresis) {
            this.nd = 0;
            this.nu++;
          }
        }
      }
    },
    buttonDown() {
      console.log("[log]" + "Down");

      var startrow = parseInt(
        this.data.experiments[this.experimentselected].startrow
      );
      var endrow = parseInt(
        this.data.experiments[this.experimentselected].endrow
      );
      var hysteresis = parseInt(
        this.data.experiments[this.experimentselected].hysteresis
      );

      if (hysteresis == 0) {
        if (this.i == startrow) return;
        else this.i -= 1;
      } else if (hysteresis != 0 && this.experimentselected == "focusdemo") {
        // if (this.i == endrow - 1) return;
        // else {
        //   if (this.nu == hysteresis) this.i += 1;
        //   else {
        //     this.nd = 0;
        //     this.nu++;
        //   }
        // }
        if (this.i == endrow - 1) return;
        else {
          this.i += 1;
          if (this.nu != hysteresis) {
            this.nd = 0;
            this.nu++;
          }
        }
        if (this.i == endrow - 1 && this.experimentselected == "focusdemo") {
          var audio = new Audio(require(".././assets/glassbreak.mp3"));
          audio.play();
        }
      } else if (hysteresis != 0 && this.experimentselected == "calibratemic") {
        if (this.i == startrow) return;
        else {
          this.i -= 1;
          if (this.nd != hysteresis) {
            this.nu = 0;
            this.nd++;
          }
        }
      }
    },
    buttonLeft() {
      console.log("[log]" + "Left");

      var startcolumn = parseInt(
        this.data.experiments[this.experimentselected].startcolumn
      );
      var hysteresis = parseInt(
        this.data.experiments[this.experimentselected].hysteresis
      );

      if (hysteresis == 0) {
        if (this.j == startcolumn) return;
        else this.j -= 1;
      }
    },
    buttonRight() {
      console.log("[log]" + "Right");

      var endcolumn = parseInt(
        this.data.experiments[this.experimentselected].endcolumn
      );

      var hysteresis = parseInt(
        this.data.experiments[this.experimentselected].hysteresis
      );

      if (hysteresis == 0) {
        if (this.j == endcolumn - 1) return;
        else this.j += 1;
      }
    },
    eventHandler(event) {
      if (event.key == "ArrowUp") {
        this.buttonUp();
      }
      if (event.key == "ArrowDown") {
        this.buttonDown();
      }
      if (event.key == "ArrowRight") {
        this.buttonRight();
      }
      if (event.key == "ArrowLeft") {
        this.buttonLeft();
      }
    },
    preLoad1(temp) {
      var index1 = "";
      var li1 = temp.toString().length;
      for (var temp1 = 0; temp1 < 4 - li1; temp1++) {
        index1 += "0";
      }
      index1 += temp;
      return require(".././assets/images/images-" +
        this.experimentselected +
        "/Cam1_" +
        index1 +
        ".jpg");
    },
    preLoad2(temp) {
      var index1 = "";
      var li1 = temp.toString().length;
      for (var temp1 = 0; temp1 < 4 - li1; temp1++) {
        index1 += "0";
      }
      index1 += temp;
      return require(".././assets/images/images-" +
        this.experimentselected +
        "/Cam2_" +
        index1 +
        ".jpg");
    },
    onChange() {
      this.mini = this.data.experiments[this.experimentselected].startrow;
      this.minj = this.data.experiments[this.experimentselected].startcolumn;
      this.maxi = this.data.experiments[this.experimentselected].endrow - 1;
      this.maxj = this.data.experiments[this.experimentselected].endcolumn - 1;

      var temp;
      for (temp = 0; temp <= 2; temp++) {
        this.images[temp].image = "";
      }
      for (temp = 1; temp <= 2; temp++) {
        this.indexes[temp].index = "";
      }
      this.i = parseInt(
        this.data.experiments[this.experimentselected].startrow
      );
      this.j = parseInt(
        this.data.experiments[this.experimentselected].startcolumn
      );
      this.nu = 0;
      this.nd = 0;
      document.getElementById(this.experimentselected).blur();
    },
    getFormat() {
      var cameras = parseInt(
        this.data.experiments[this.experimentselected].cameras
      );
      var frames = parseInt(
        this.data.experiments[this.experimentselected].frames
      );
      if (frames == 3 && frames == cameras + 1) {
        return 1;
      } else if (frames == 2 && frames == cameras + 1) {
        return 2;
      } else if (frames == 2 && frames == cameras) {
        return 3;
      }
    },
    getImage() {
      var cameras, frames, temp;
      cameras = parseInt(
        this.data.experiments[this.experimentselected].cameras
      );
      frames = parseInt(this.data.experiments[this.experimentselected].frames);
      this.getIndex();
      if (frames == cameras + 1) {
        this.images[0].image = require(".././assets/images/images-" +
          this.experimentselected +
          "/Cam_0000.jpg");
      }
      for (temp = 1; temp <= cameras; temp++) {
        this.images[temp].image = require(".././assets/images/images-" +
          this.experimentselected +
          "/Cam" +
          temp +
          "_" +
          this.indexes[temp].index +
          ".jpg");
      }
    },
    getIndex() {
      var temp;
      var hysteresis = parseInt(
        this.data.experiments[this.experimentselected].hysteresis
      );
      var i1 = 0,
        i2 = 0,
        li1 = 0,
        li2 = 0;
      var index1, index2;
      if (this.experimentselected == "focusdemo") {
        i2 = this.i - hysteresis;
        if (!(this.nu == 0 && this.nd == 0)) {
          if (this.nu != hysteresis && this.nd != hysteresis)
            i2 = parseInt(this.indexes[2].index);
        }
        if (i2 < 0) i2 = 0;
        i1 = this.i;
        li2 = i2.toString().length;
        li1 = i1.toString().length;
        index2 = "";
        index1 = "";
        for (temp = 0; temp < 4 - li2; temp++) {
          index2 += "0";
        }
        for (temp = 0; temp < 4 - li1; temp++) {
          index1 += "0";
        }
        index2 += i2;
        index1 += i1;
        this.indexes[2].index = index2;
        this.indexes[1].index = index1;
      } else if (this.experimentselected == "calibratemic") {
        i1 = this.i - hysteresis;
        if (!(this.nu == 0 && this.nd == 0)) {
          if (this.nu != hysteresis && this.nd != hysteresis)
            i1 = parseInt(this.indexes[1].index);
        }
        if (i1 < 0) i1 = 0;
        i2 = this.i;
        li1 = i1.toString().length;
        li2 = i2.toString().length;
        index1 = "";
        index2 = "";
        for (temp = 0; temp < 4 - li1; temp++) {
          index1 += "0";
        }
        for (temp = 0; temp < 4 - li2; temp++) {
          index2 += "0";
        }
        index1 += i1;
        index2 += i2;
        this.indexes[1].index = index1;
        this.indexes[2].index = index2;
      } else {
        var hvtype = parseInt(
          this.data.experiments[this.experimentselected].hvtype
        );
        var li, lj;
        var index = "";
        li = this.i.toString().length;
        lj = this.j.toString().length;
        if (hvtype == 1) {
          for (temp = 0; temp < 4 - lj; temp++) {
            index += "0";
          }
          index += this.j;
        } else if (hvtype == 2) {
          for (temp = 0; temp < 4 - li; temp++) {
            index += "0";
          }
          index += this.i;
        } else if (hvtype == 3) {
          for (temp = 0; temp < 2 - li; temp++) {
            index += "0";
          }
          index += this.i;
          for (temp = 0; temp < 2 - lj; temp++) {
            index += "0";
          }
          index += this.j;
        }
        this.indexes[1].index = index;
        this.indexes[2].index = index;
      }
      //return index;
    },
  },
  created() {
    this.experimentselected = "focusdemo";
  },
  watch: {
    experimentselected: function () {
      console.log("[log]: in watch");
      var startrow = parseInt(
        this.data.experiments[this.experimentselected].startrow
      );
      var startcolumn = parseInt(
        this.data.experiments[this.experimentselected].startcolumn
      );
      var endrow = parseInt(
        this.data.experiments[this.experimentselected].endrow
      );
      var endcolumn = parseInt(
        this.data.experiments[this.experimentselected].endcolumn
      );
      var hvtype = parseInt(
        this.data.experiments[this.experimentselected].hvtype
      );
      var cameras = parseInt(
        this.data.experiments[this.experimentselected].cameras
      );
      var frames = parseInt(
        this.data.experiments[this.experimentselected].frames
      );
      var image;
      var temp, temp1, temp2, temp3;
      var index, li, lj;
      if (frames == cameras + 1) {
        image = new Image();
        image.src = require(".././assets/images/images-" +
          this.experimentselected +
          "/Cam_0000.jpg");
      }
      if (hvtype == 1) {
        for (temp1 = startcolumn; temp1 < endcolumn; temp1++) {
          index = "";
          lj = temp1.toString().length;
          for (temp2 = 0; temp2 < 4 - lj; temp2++) {
            index += "0";
          }
          index += temp1;
          for (temp = 1; temp <= cameras; temp++) {
            image = new Image();
            image.src = require(".././assets/images/images-" +
              this.experimentselected +
              "/Cam" +
              temp +
              "_" +
              index +
              ".jpg");
          }
        }
      } else if (hvtype == 2) {
        for (temp1 = startrow; temp1 < endrow; temp1++) {
          index = "";
          li = temp1.toString().length;
          for (temp2 = 0; temp2 < 4 - li; temp2++) {
            index += "0";
          }
          index += temp1;
          for (temp = 1; temp <= cameras; temp++) {
            image = new Image();
            image.src = require(".././assets/images/images-" +
              this.experimentselected +
              "/Cam" +
              temp +
              "_" +
              index +
              ".jpg");
          }
        }
      } else if (hvtype == 3) {
        for (temp1 = startrow; temp1 < endrow; temp1++) {
          for (temp2 = startcolumn; temp2 < endcolumn; temp2++) {
            index = "";

            li = temp1.toString().length;
            lj = temp2.toString().length;
            for (temp3 = 0; temp3 < 2 - li; temp3++) {
              index += "0";
            }
            index += temp1;
            for (temp3 = 0; temp3 < 2 - lj; temp3++) {
              index += "0";
            }
            index += temp2;
            for (temp = 1; temp <= cameras; temp++) {
              image = new Image();
              image.src = require(".././assets/images/images-" +
                this.experimentselected +
                "/Cam" +
                temp +
                "_" +
                index +
                ".jpg");
            }
          }
        }
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.eventHandler);
    document.addEventListener("keydown", function (event) {
      if (event.key == "ArrowUp" || event.key == "ArrowDown") {
        event.preventDefault();
      }
    });
    this.getImage();
  },
  updated() {
    this.getImage();
  },
};
</script>

<style>
.input-group-prepend-1 {
  width: 55%;
}

.input-group-prepend-1 span {
  width: 100%;
  overflow: hidden;
}

div#preload {
  display: none;
}
</style>
